import React, { useState, useEffect, useCallback } from "react";
import AsyncSelect from "react-select/async";
import { customFetch } from '../apiClient';
import * as XLSX from "xlsx"; 

import defaultLogo from "../assests/kamlaLogo.png"; 

const PurchaseReports = () => {
  const [activeTab, setActiveTab] = useState("register");
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [companyInfo, setCompanyInfo] = useState(null);
  
  const [filters, setFilters] = useState({
    fromDate: new Date().toISOString().split("T")[0],
    toDate: new Date().toISOString().split("T")[0],
    vendorId: null, 
    vendorName: "",
    medicineName: "" 
  });

  const [summary, setSummary] = useState({ totalTaxable: 0, totalGst: 0, totalAmount: 0, totalBills: 0 });
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(50);

  // Expandable Rows States
  const [expandedRow, setExpandedRow] = useState(null);
  const [expandedData, setExpandedData] = useState([]);
  const [expandLoading, setExpandLoading] = useState(false);

  const handleFilterChange = (e) => setFilters(prev => ({ ...prev, [e.target.name]: e.target.value }));

  useEffect(() => {
    const fetchCompanyInfo = async () => {
    try {
    const res = await customFetch(`/PharmaCompany`);
        if (res.ok) {
          const data = await res.json();
          if (data && data.length > 0) setCompanyInfo(data[0]);
        }
      } catch (err) { console.error("Failed to fetch company info", err); }
    };
    fetchCompanyInfo();
  }, []);

  const loadVendorOptions = async (inputValue) => {
    if (!inputValue || !inputValue.trim()) return [];
  try {
    const res = await customFetch(`/VendorDT/search?name=${encodeURIComponent(inputValue.trim())}`);
      if (!res.ok) return [];
      const data = await res.json();
      return data.map((v) => ({ value: v.vid, label: v.vendorName }));
    } catch (err) { return []; }
  };

  const fetchReport = async () => {
    setLoading(true); setError(""); setReportData([]); setCurrentPage(1); setExpandedRow(null);
    try {
     
      
      // ✅ FIX 1: URLSearchParams mein searchTerm tabhi bhejo jab usme value ho
      const params = new URLSearchParams({
         fromDate: filters.fromDate,
         toDate: filters.toDate
      });

      if (filters.vendorId) params.append("vendorId", filters.vendorId);
      if (activeTab === 'item-wise' && filters.medicineName && filters.medicineName.trim() !== "") {
         params.append("searchTerm", filters.medicineName.trim());
      }

      let endpoint = activeTab; 

     const res = await customFetch(`/PurchaseReports/${endpoint}?${params.toString()}`);

      if (!res.ok) throw new Error(await res.text());
      const data = await res.json();
      console.log(`=== DATA FROM API FOR TAB: ${activeTab} ===`);
      console.log(data);
      if (data.length > 0) {
          console.log("First Row Keys:", Object.keys(data[0]));
          console.log("First Row Data:", data[0]);
      }
      setReportData(data);

      let sTaxable = 0, sGst = 0, sAmount = 0;
      if (activeTab === 'register') {
         sTaxable = data.reduce((s, i) => s + (i.taxableAmount || i.TaxableAmount || 0), 0);
         sGst = data.reduce((s, i) => s + (i.gstAmount || i.GSTAmount || 0), 0);
         sAmount = data.reduce((s, i) => s + (i.netAmount || i.NetAmount || 0), 0);
      } else if (activeTab === 'vendor-wise') {
         sTaxable = data.reduce((s, i) => s + (i.totalTaxable || i.TotalTaxable || 0), 0);
         sGst = data.reduce((s, i) => s + (i.totalGST || i.TotalGST || 0), 0);
         sAmount = data.reduce((s, i) => s + (i.totalPurchaseValue || i.TotalPurchaseValue || 0), 0);
      } else if (activeTab === 'debit-register') {
         sTaxable = data.reduce((s, i) => s + (i.taxableAmount || i.TaxableAmount || 0), 0);
         sGst = data.reduce((s, i) => s + (i.gstAmount || i.GSTAmount || 0), 0);
         sAmount = data.reduce((s, i) => s + (i.returnAmount || i.ReturnAmount || 0), 0);
      } else if (activeTab === 'item-wise') {
         sAmount = data.reduce((s, i) => s + (i.netAmount || i.NetAmount || 0), 0); 
      }
      setSummary({ totalTaxable: sTaxable, totalGst: sGst, totalAmount: sAmount, totalBills: data.length });

    } catch (err) { setError(err.message); } finally { setLoading(false); }
  };

  useEffect(() => { fetchReport(); }, [activeTab]);

  const toggleExpand = async (purchId) => {
    // API se PurchID alag case mein aa sakti hai (purchId ya PurchID)
    const pId = purchId || reportData.find(x => x.PurchID === purchId)?.PurchID;

    // 👆 ======================= 👆
    if (!pId) return;

    if (expandedRow === pId) {
      setExpandedRow(null);
      setExpandedData([]);
      return;
    }
    setExpandedRow(pId);
    setExpandLoading(true);
   
     try {
    const res = await customFetch(`/PurchaseReports/bill-items/${pId}`);
      if (res.ok) {
        const data = await res.json();
        setExpandedData(data);
      }
    } catch (err) { console.error("Failed to load bill items", err); }
    finally { setExpandLoading(false); }
  };

  const totalPages = Math.ceil(reportData.length / rowsPerPage) || 1;
  const displayedData = reportData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const d = new Date(dateString);
    return `${d.getDate().toString().padStart(2, '0')}/${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getFullYear()}`;
  };

  // ==============================================================
  // EXCEL EXPORT
  // ==============================================================
  const exportToExcel = useCallback(() => {
    if (reportData.length === 0) { alert("No data available to export!"); return; }

    let formattedData = [];
    if (activeTab === 'register') {
      formattedData = reportData.map((item, i) => ({
        "S.No": i + 1, "Date": formatDate(item.billDate || item.BillDate), "Bill No": item.billNo || item.BillNo,
        "Vendor": item.vendorName || item.VendorName, "GSTIN": item.gstin || item.GSTIN,
        "Taxable (₹)": item.taxableAmount || item.TaxableAmount, "GST (₹)": item.gstAmount || item.GSTAmount, "Net Amount (₹)": item.netAmount || item.NetAmount, "User": item.createdBy || item.CreatedBy
      }));
    } else if (activeTab === 'vendor-wise') {
      formattedData = reportData.map((item, i) => ({
        "Rank": i + 1, "Vendor Name": item.vendorName || item.VendorName, "Contact": item.contactNo || item.ContactNo,
        "Total Bills": item.totalBills || item.TotalBills, "Total Taxable (₹)": item.totalTaxable || item.TotalTaxable, "Total Purchase (₹)": item.totalPurchaseValue || item.TotalPurchaseValue
      }));
    } else if (activeTab === 'debit-register') {
      formattedData = reportData.map((item, i) => ({
        "S.No": i + 1, "Return Date": formatDate(item.returnDate || item.ReturnDate), "Voucher No": item.voucherNo || item.VoucherNo,
        "Vendor": item.vendorName || item.VendorName, "Ref Bill No": item.refBillNo || item.RefBillNo, "Reason": item.reason || item.Reason,
        "Taxable (₹)": item.taxableAmount || item.TaxableAmount, "Return Amount (₹)": item.returnAmount || item.ReturnAmount
      }));
    } else if (activeTab === 'item-wise') {
      formattedData = reportData.map((item, i) => {
        const pQty = item.paidQty || item.PaidQty || 0;
        const fQty = item.freeQty || item.FreeQty || 0;
        return {
          "S.No": i + 1, "Date": formatDate(item.billDate || item.BillDate), "Vendor": item.vendorName || item.VendorName, "Bill No": item.billNo || item.BillNo,
          "Medicine": item.medicine || item.Medicine, "Batch": item.batchNo || item.BatchNo, "Paid Qty": pQty, "Free Qty": fQty, "Total Qty": (pQty + fQty),
          "Purchase Rate (₹)": item.purchaseRate || item.PurchaseRate, "Net Amount (₹)": item.netAmount || item.NetAmount
        };
      });
    }

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Report");
    XLSX.writeFile(workbook, `PURCHASE_${activeTab.toUpperCase()}_${filters.fromDate}_to_${filters.toDate}.xlsx`);
  }, [reportData, activeTab, filters]);

  // ==============================================================
  // TALLY / MARG STYLE PRINT & PDF
  // ==============================================================
  const handlePrint = useCallback(() => {
    if (reportData.length === 0) { alert("No data available to print!"); return; }

    const logoSource = companyInfo?.logoBase64 ? `data:image/png;base64,${companyInfo.logoBase64}` : defaultLogo;
    const compName = companyInfo?.company_Name || "HOSPITAL / PHARMACY STORE";
    const compAddress = companyInfo?.address || "";
    const compContact = companyInfo?.contact1 ? `Ph: ${companyInfo.contact1}` : "";
    const compGst = companyInfo?.reg_No ? `DL/GST: ${companyInfo.reg_No}` : "";

    const ROWS_PER_PAGE = 35; 
    const pages = [];
    let runningTotal = 0;

    for (let i = 0; i < reportData.length; i += ROWS_PER_PAGE) {
      const pageItems = reportData.slice(i, i + ROWS_PER_PAGE);
      const broughtForward = runningTotal;
      
      const pageTotal = pageItems.reduce((sum, item) => {
          if (activeTab === 'vendor-wise') return sum + (item.totalPurchaseValue || item.TotalPurchaseValue || 0);
          if (activeTab === 'debit-register') return sum + (item.returnAmount || item.ReturnAmount || 0);
          return sum + (item.netAmount || item.NetAmount || 0);
      }, 0);

      runningTotal += pageTotal;
      
      pages.push({
        items: pageItems,
        startIndex: i,
        broughtForward: broughtForward,
        carriedForward: runningTotal,
        isLastPage: i + ROWS_PER_PAGE >= reportData.length
      });
    }

    const reportHtml = pages.map((page, pageIndex) => {
      
      let thHtml = "";
      if (activeTab === 'register') thHtml = `<th style="text-align:left">Date</th><th style="text-align:left">Bill No</th><th style="text-align:left">Vendor</th><th>GSTIN</th><th style="text-align:right">Taxable</th><th style="text-align:right">GST</th><th style="text-align:right">Net Amount</th>`;
      else if (activeTab === 'vendor-wise') thHtml = `<th style="text-align:left">Rank</th><th style="text-align:left">Vendor Name</th><th style="text-align:left">Contact</th><th style="text-align:center">Bills</th><th style="text-align:right">Taxable</th><th style="text-align:right">Purchase Value</th>`;
      else if (activeTab === 'debit-register') thHtml = `<th style="text-align:left">Date</th><th style="text-align:left">Voucher No</th><th style="text-align:left">Vendor</th><th>Ref Bill</th><th>Reason</th><th style="text-align:right">Taxable</th><th style="text-align:right">Return Amount</th>`;
      else if (activeTab === 'item-wise') thHtml = `<th style="text-align:left">Date</th><th style="text-align:left">Bill No</th><th style="text-align:left">Vendor & Medicine</th><th>Batch</th><th style="text-align:right">Paid</th><th style="text-align:right">Free</th><th style="text-align:right">Total Qty</th><th style="text-align:right">Amount</th>`;

      const trHtml = page.items.map((item, idx) => {
        if (activeTab === 'register') return `<tr><td style="text-align:left">${formatDate(item.billDate || item.BillDate)}</td><td style="text-align:left">${item.billNo || item.BillNo}</td><td style="text-align:left">${item.vendorName || item.VendorName}</td><td style="text-align:center">${item.gstin || item.GSTIN || '-'}</td><td style="text-align:right">${(item.taxableAmount || item.TaxableAmount || 0)?.toFixed(2)}</td><td style="text-align:right">${(item.gstAmount || item.GSTAmount || 0)?.toFixed(2)}</td><td style="text-align:right; font-weight:bold;">${(item.netAmount || item.NetAmount || 0)?.toFixed(2)}</td></tr>`;
        if (activeTab === 'vendor-wise') return `<tr><td style="text-align:left">#${page.startIndex + idx + 1}</td><td style="text-align:left">${item.vendorName || item.VendorName}</td><td style="text-align:left">${item.contactNo || item.ContactNo || '-'}</td><td style="text-align:center">${item.totalBills || item.TotalBills}</td><td style="text-align:right">${(item.totalTaxable || item.TotalTaxable || 0)?.toFixed(2)}</td><td style="text-align:right; font-weight:bold;">${(item.totalPurchaseValue || item.TotalPurchaseValue || 0)?.toFixed(2)}</td></tr>`;
        if (activeTab === 'debit-register') return `<tr><td style="text-align:left">${formatDate(item.returnDate || item.ReturnDate)}</td><td style="text-align:left">${item.voucherNo || item.VoucherNo}</td><td style="text-align:left">${item.vendorName || item.VendorName}</td><td style="text-align:center">${item.refBillNo || item.RefBillNo}</td><td style="text-align:center">${item.reason || item.Reason || '-'}</td><td style="text-align:right">${(item.taxableAmount || item.TaxableAmount || 0)?.toFixed(2)}</td><td style="text-align:right; font-weight:bold; color:red;">${(item.returnAmount || item.ReturnAmount || 0)?.toFixed(2)}</td></tr>`;
        if (activeTab === 'item-wise') {
           const pQty = item.paidQty || item.PaidQty || 0;
           const fQty = item.freeQty || item.FreeQty || 0;
           return `<tr><td style="text-align:left">${formatDate(item.billDate || item.BillDate)}</td><td style="text-align:left">${item.billNo || item.BillNo}</td><td style="text-align:left"><div><small style="color:#555">${item.vendorName || item.VendorName}</small></div><strong>${item.medicine || item.Medicine}</strong></td><td style="text-align:center">${item.batchNo || item.BatchNo}</td><td style="text-align:right">${pQty}</td><td style="text-align:right">${fQty}</td><td style="text-align:right; font-weight:bold;">${pQty + fQty}</td><td style="text-align:right; font-weight:bold;">${(item.netAmount || item.NetAmount || 0)?.toFixed(2)}</td></tr>`;
        }
      }).join('');

      let colSpanBF = '6';
      if(activeTab === 'vendor-wise') colSpanBF = '5';
      if(activeTab === 'item-wise') colSpanBF = '7';

      const bfHtml = pageIndex > 0 ? `
        <tr style="background:#f9f9f9; border-bottom: 1px solid #000;">
          <td colspan="${colSpanBF}" style="text-align:right; font-weight:bold; font-style:italic;">Brought Forward (B/F):</td>
          <td style="text-align:right; font-weight:bold;">${page.broughtForward.toFixed(2)}</td>
        </tr>` : "";

      const cfHtml = `
        <tr style="background:#e0e0e0;">
          <td colspan="${colSpanBF}" style="text-align:right; font-weight:bold; font-size:12px; padding: 6px;">
             ${page.isLastPage ? 'GRAND TOTAL:' : 'Carried Forward (C/F):'}
          </td>
          <td style="text-align:right; font-weight:bold; font-size:12px; padding: 6px;">${page.carriedForward.toFixed(2)}</td>
        </tr>`;

      return `
        <div class="a4-page ${page.isLastPage ? 'last-page' : ''}">
          <div class="marg-header">
            <img src="${logoSource}" alt="Logo" class="print-logo"/>
            <div class="marg-header-center">
              <h2>${compName}</h2>
              <p>${compAddress}</p>
              <p><strong>${compContact}</strong></p>
            </div>
            <div class="marg-header-right">
              ${compGst ? `<span><strong>${compGst}</strong></span><br/>` : ""}
              <span><strong>Page:</strong> ${pageIndex + 1} of ${pages.length}</span><br/>
              <span><strong>Print Date:</strong> ${new Date().toLocaleDateString('en-GB')}</span>
            </div>
          </div>
          
          <div class="marg-title-strip">
            PURCHASE ${activeTab.toUpperCase().replace('-', ' ')}
            (FROM: ${formatDate(filters.fromDate)} TO: ${formatDate(filters.toDate)})
          </div>

          <div class="content-area">
            <table class="items-table">
              <thead><tr>${thHtml}</tr></thead>
              <tbody>${bfHtml}${trHtml}</tbody>
            </table>
          </div>
          
          <div class="footer-area">
             <table class="items-table" style="margin:0; border-top: 2px solid #000;"><tbody>${cfHtml}</tbody></table>
          </div>
        </div>
      `;
    }).join("");

    const pw = window.open("", "_blank", "width=900,height=700");
    pw.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <title>Purchase Report</title>
        <style>
          * { box-sizing: border-box; margin: 0; padding: 0; font-family: Arial, sans-serif; }
          body { background: #525659; display: flex; flex-direction: column; align-items: center; padding: 20px; }
          @media print {
            @page { size: A4 portrait; margin: 8mm; }
            body { background: #fff; padding: 0; margin: 0;}
            .a4-page { width: 100% !important; min-height: 275mm; page-break-after: always; margin: 0 !important; border: 1px solid #000 !important; }
            .a4-page.last-page { page-break-after: auto; }
          }
          .a4-page { background: #fff; width: 210mm; min-height: 280mm; border: 2px solid #000; margin-bottom: 20mm; display: flex; flex-direction: column; box-shadow: 0 0 10px rgba(0,0,0,0.5); }
          .marg-header { border-bottom: 2px solid #000; padding: 10px 15px; display: flex; justify-content: space-between; align-items: center; }
          .print-logo { width: 75px; height: 75px; object-fit: contain; flex-shrink:0;}
          .marg-header-center { flex-grow: 1; padding: 0 15px; text-align:center;}
          .marg-header-center h2 { margin: 0 0 4px 0; font-size: 18px; text-transform: uppercase; }
          .marg-title-strip { background-color: #e0e0e0 !important; -webkit-print-color-adjust: exact !important; border-bottom: 2px solid #000; text-align: center; padding: 5px; font-weight: bold; font-size: 13px; }
          .content-area { flex-grow: 1; padding: 0; } 
          .footer-area { margin-top: auto; }
          .items-table { width: 100%; border-collapse: collapse; font-size: 11px; }
          .items-table th { border-bottom: 2px solid #000; border-right: 1px solid #ccc; background-color: #f1f1f1 !important; padding: 6px 8px; font-weight: bold; text-transform: uppercase;}
          .items-table td { border-right: 1px dashed #ccc; border-bottom: 1px dashed #ccc; padding: 5px 8px; }
          .items-table th:last-child, .items-table td:last-child { border-right: none; }
        </style>
      </head>
      <body>${reportHtml}</body>
      </html>
    `);
    pw.document.close();
    setTimeout(() => { pw.focus(); pw.print(); }, 500);
  }, [reportData, activeTab, filters, companyInfo]); 

  useEffect(() => {
    const handleExportEvent = (e) => {
      const exportType = e.detail?.type;
      if (exportType === 'excel') exportToExcel();
      else if (exportType === 'pdf' || exportType === 'print') handlePrint(); 
    };
    window.addEventListener("exportData", handleExportEvent);
    return () => window.removeEventListener("exportData", handleExportEvent);
  }, [exportToExcel, handlePrint]);

  return (
    <div className="report-container">
      <div className="report-card">
        
        <div className="card-header">
          <div className="header-left">
             <div className="header-icon"><i className="bi bi-truck"></i></div>
             <div className="header-text"><h5>Purchase Reports</h5><p>Vendor Bills, Items, Returns & Analysis</p></div>
          </div>
        </div>

        <div className="tabs-header">
           <button className={`tab-btn ${activeTab === 'register' ? 'active' : ''}`} onClick={() => setActiveTab('register')}>
              <i className="bi bi-file-earmark-text"></i> Purchase Register
           </button>
           <button className={`tab-btn ${activeTab === 'item-wise' ? 'active' : ''}`} onClick={() => setActiveTab('item-wise')}>
              <i className="bi bi-capsule"></i> Item-Wise Purchase
           </button>
           <button className={`tab-btn ${activeTab === 'vendor-wise' ? 'active' : ''}`} onClick={() => setActiveTab('vendor-wise')}>
              <i className="bi bi-shop"></i> Vendor Wise
           </button>
           <button className={`tab-btn ${activeTab === 'debit-register' ? 'active' : ''}`} onClick={() => setActiveTab('debit-register')}>
              <i className="bi bi-arrow-counterclockwise"></i> Purchase Returns (Debit)
           </button>
        </div>

        <div className="card-content">
          {error && <div className="alert-custom alert-danger">{error}</div>}

          <div className="filter-bar">
             <div className="form-group">
                <label>From Date</label>
                <input type="date" name="fromDate" value={filters.fromDate} onChange={handleFilterChange} className="form-input" />
             </div>
             <div className="form-group">
                <label>To Date</label>
                <input type="date" name="toDate" value={filters.toDate} onChange={handleFilterChange} className="form-input" />
             </div>
             
             {activeTab !== 'vendor-wise' && (
                 <div className="form-group" style={{minWidth: '200px'}}>
                    <label>Filter by Vendor</label>
                    <AsyncSelect 
                        cacheOptions defaultOptions loadOptions={loadVendorOptions} 
                        onChange={(opt) => setFilters(prev => ({...prev, vendorId: opt?.value, vendorName: opt?.label}))} 
                        value={filters.vendorId ? {value: filters.vendorId, label: filters.vendorName} : null}
                        placeholder="All Vendors..." isClearable 
                    />
                 </div>
             )}

             {activeTab === 'item-wise' && (
                 <div className="form-group" style={{flex: 2}}>
                    <label>Search Medicine</label>
                    <input type="text" name="medicineName" value={filters.medicineName} onChange={handleFilterChange} className="form-input" placeholder="Type medicine name..." />
                 </div>
             )}

             <button className="btn-search" onClick={fetchReport} disabled={loading}>
                {loading ? 'Wait...' : 'View Report'}
             </button>
          </div>

          {!loading && reportData.length > 0 && (
             <div className="summary-cards">
                <div className="s-card total">
                   <div className="s-label">{activeTab === 'debit-register' ? 'Total Return Value' : 'Total Purchase Value'}</div>
                   <div className="s-value">₹ {summary.totalAmount.toLocaleString('en-IN', {minimumFractionDigits: 2})}</div>
                   <div className="s-sub">{summary.totalBills} Records</div>
                </div>
                {(activeTab !== 'item-wise') && (
                  <>
                    <div className="s-card cash">
                       <div className="s-label">Total Taxable</div>
                       <div className="s-value">₹ {summary.totalTaxable.toLocaleString('en-IN', {minimumFractionDigits: 2})}</div>
                    </div>
                    <div className="s-card upi">
                       <div className="s-label">Total GST</div>
                       <div className="s-value">₹ {summary.totalGst.toLocaleString('en-IN', {minimumFractionDigits: 2})}</div>
                    </div>
                  </>
                )}
             </div>
          )}

          <div className="table-section">
            <div className="table-responsive">
              <table className="custom-table">
                <thead>
                  {activeTab === 'register' && (
                     <tr>
                        <th className="text-center" style={{width:'40px'}}>#</th>
                        <th className="text-start">Date</th><th className="text-start">Bill No</th><th className="text-start">Vendor</th><th className="text-center">GSTIN</th>
                        <th className="text-end">Taxable</th><th className="text-end">GST</th>
                        <th className="text-end">Net Amount</th><th className="text-start">Entry By</th>
                     </tr>
                  )}
                  {activeTab === 'item-wise' && (
                     <tr>
                        <th className="text-start">Date</th><th className="text-start">Vendor</th><th className="text-start">Bill No</th><th className="text-start">Medicine Name</th><th className="text-start">Batch</th>
                        <th className="text-end">Paid Qty</th><th className="text-end">Free Qty</th><th className="text-end">Total Qty</th><th className="text-end">P.Rate</th><th className="text-end">Amount</th>
                     </tr>
                  )}
                  {activeTab === 'vendor-wise' && (
                     <tr>
                        <th className="text-start">Rank</th><th className="text-start">Vendor Name</th><th className="text-start">Contact</th>
                        <th className="text-center">Total Bills</th>
                        <th className="text-end">Total Taxable</th>
                        <th className="text-end">Total Purchase</th>
                     </tr>
                  )}
                  {activeTab === 'debit-register' && (
                     <tr>
                        <th className="text-start">Date</th><th className="text-start">Voucher No</th><th className="text-start">Vendor</th><th className="text-center">Ref Bill</th>
                        <th className="text-center">Reason</th>
                        <th className="text-end">Taxable</th><th className="text-end">Return Amount</th>
                     </tr>
                  )}
                </thead>
                <tbody>
                  {loading ? (
                    <tr><td colSpan="10" className="empty-state">Loading data...</td></tr>
                  ) : displayedData.length === 0 ? (
                    <tr><td colSpan="10" className="empty-state">No records found.</td></tr>
                  ) : (
                    displayedData.map((item, index) => {
                      const currentPurchId = item.purchID || item.PurchID; // Handle both cases
                      return (
                      <React.Fragment key={index}>
                        {activeTab === 'register' && <>
                           <tr>
                             <td className="text-center">
                               {/* ✅ EXPAND BUTTON FIXED */}
                               <button className="btn btn-sm btn-light p-0 px-1 border" onClick={() => toggleExpand(currentPurchId)}>
                                 <i className={expandedRow === currentPurchId ? "bi bi-dash text-danger" : "bi bi-plus text-primary"} style={{fontSize:'14px', fontWeight:'bold'}}></i>
                               </button>
                             </td>
                             <td className="text-start text-muted">{formatDate(item.billDate || item.BillDate)}</td>
                             <td className="text-start fw-bold text-primary">{item.billNo || item.BillNo}</td>
                             <td className="text-start fw-medium">{item.vendorName || item.VendorName}</td>
                             <td className="text-center">{item.gstin || item.GSTIN || '-'}</td>
                             <td className="text-end">₹{(item.taxableAmount || item.TaxableAmount || 0)?.toFixed(2)}</td>
                             <td className="text-end">₹{(item.gstAmount || item.GSTAmount || 0)?.toFixed(2)}</td>
                             <td className="text-end fw-bold text-success">₹{(item.netAmount || item.NetAmount || 0)?.toFixed(2)}</td>
                             <td className="text-start text-muted text-sm">{item.createdBy || item.CreatedBy}</td>
                           </tr>
                           {/* ✅ NESTED ITEMS TABLE FIXED MAPPING */}
                           {expandedRow === currentPurchId && (
                             <tr>
                               <td colSpan="9" className="bg-light p-3 border-bottom">
                                 {expandLoading ? (
                                   <div className="text-center text-muted"><div className="spinner-border spinner-border-sm me-2"></div>Loading items...</div>
                                 ) : (
                                   <table className="table table-sm table-bordered bg-white mb-0 shadow-sm rounded" style={{fontSize: '11px'}}>
                                     <thead className="table-secondary">
                                       <tr>
                                         <th className="text-start">Medicine Name</th>
                                         <th className="text-start">Batch</th>
                                         <th className="text-center">Exp Date</th>
                                         <th className="text-end text-primary">Paid Qty</th>
                                         <th className="text-end text-success">Free Qty</th>
                                         <th className="text-end fw-bold">Total Qty</th>
                                         <th className="text-end">P.Rate</th>
                                         <th className="text-end">Discount</th>
                                         <th className="text-end">GST %</th>
                                         <th className="text-end fw-bold">Amount</th>
                                       </tr>
                                     </thead>
                                     <tbody>
                                       {expandedData.map((exItem, exIdx) => {
                                         const mPaidQty = exItem.paidQty || exItem.PaidQty || 0;
                                         const mFreeQty = exItem.freeQty || exItem.FreeQty || 0;
                                         return (
                                         <tr key={exIdx}>
                                           <td className="text-start fw-bold">{exItem.medicine || exItem.Medicine}</td>
                                           <td className="text-start">{exItem.batchNo || exItem.BatchNo}</td>
                                           <td className="text-center">{formatDate(exItem.expDate || exItem.ExpDate)}</td>
                                           <td className="text-end text-primary fw-medium">{mPaidQty}</td>
                                           <td className="text-end text-success fw-medium">{mFreeQty}</td>
                                           <td className="text-end fw-bold bg-light">{mPaidQty + mFreeQty}</td>
                                           <td className="text-end">₹{(exItem.purchaseRate || exItem.PurchaseRate || 0)?.toFixed(2)}</td>
                                           <td className="text-end">{(exItem.discount || exItem.Discount || 0)?.toFixed(2)}</td>
                                           <td className="text-end">{(exItem.gstPercent || exItem.GstPercent || 0)}%</td>
                                           <td className="text-end fw-bold">₹{(exItem.netAmount || exItem.NetAmount || 0)?.toFixed(2)}</td>
                                         </tr>
                                       )})}
                                     </tbody>
                                   </table>
                                 )}
                               </td>
                             </tr>
                           )}
                        </>}

                        {activeTab === 'item-wise' && <tr>
                           <td className="text-start text-muted">{formatDate(item.billDate || item.BillDate)}</td>
                           <td className="text-start"><small className="text-muted d-block" style={{fontSize:'10px', lineHeight:'1'}}>{item.vendorName || item.VendorName}</small></td>
                           <td className="text-start fw-medium text-primary">{item.billNo || item.BillNo}</td>
                           <td className="text-start fw-bold">{item.medicine || item.Medicine}</td>
                           <td className="text-start">{item.batchNo || item.BatchNo}</td>
                           <td className="text-end text-primary fw-medium">{item.paidQty || item.PaidQty || 0}</td>
                           <td className="text-end text-success fw-medium">{item.freeQty || item.FreeQty || 0}</td>
                           <td className="text-end fw-bold bg-light">{(item.paidQty || item.PaidQty || 0) + (item.freeQty || item.FreeQty || 0)}</td>
                           <td className="text-end text-muted">₹{(item.purchaseRate || item.PurchaseRate || 0)?.toFixed(2)}</td>
                           <td className="text-end fw-bold text-success">₹{(item.netAmount || item.NetAmount || 0)?.toFixed(2)}</td>
                        </tr>}

                        {activeTab === 'vendor-wise' && <tr>
                           <td className="text-start text-muted">#{(currentPage - 1) * rowsPerPage + index + 1}</td>
                           <td className="text-start fw-medium">{item.vendorName || item.VendorName}</td>
                           <td className="text-start">{item.contactNo || item.ContactNo || '-'}</td>
                           <td className="text-center">{item.totalBills || item.TotalBills}</td>
                           <td className="text-end">₹{(item.totalTaxable || item.TotalTaxable || 0)?.toFixed(2)}</td>
                           <td className="text-end fw-bold text-primary">₹{(item.totalPurchaseValue || item.TotalPurchaseValue || 0)?.toFixed(2)}</td>
                        </tr>}

                        {activeTab === 'debit-register' && <tr>
                           <td className="text-start text-muted">{formatDate(item.returnDate || item.ReturnDate)}</td>
                           <td className="text-start fw-bold text-danger">{item.voucherNo || item.VoucherNo}</td>
                           <td className="text-start fw-medium">{item.vendorName || item.VendorName}</td>
                           <td className="text-center text-muted">{item.refBillNo || item.RefBillNo}</td>
                           <td className="text-center">{item.reason || item.Reason || '-'}</td>
                           <td className="text-end">₹{(item.taxableAmount || item.TaxableAmount || 0)?.toFixed(2)}</td>
                           <td className="text-end fw-bold text-danger">₹{(item.returnAmount || item.ReturnAmount || 0)?.toFixed(2)}</td>
                        </tr>}
                      </React.Fragment>
                    )})
                  )}
                </tbody>
              </table>
            </div>

            {!loading && reportData.length > 0 && (
              <div className="d-flex justify-content-between align-items-center p-2 border-top bg-light">
                <div className="d-flex align-items-center gap-2">
                  <span className="text-muted" style={{fontSize:'12px'}}>Rows per page:</span>
                  <select 
                    className="form-select form-select-sm" 
                    style={{width: '70px', fontSize: '12px', padding: '2px 10px'}}
                    value={rowsPerPage} 
                    onChange={(e) => { setRowsPerPage(Number(e.target.value)); setCurrentPage(1); setExpandedRow(null); }}
                  >
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </select>
                </div>
                
                <div className="d-flex align-items-center gap-2">
                  <span className="text-muted" style={{fontSize:'12px', marginRight:'10px'}}>
                    Showing {(currentPage - 1) * rowsPerPage + 1} to {Math.min(currentPage * rowsPerPage, reportData.length)} of {reportData.length} entries
                  </span>
                  <button 
                    className="btn btn-sm btn-outline-secondary py-1 px-2" 
                    disabled={currentPage === 1} 
                    onClick={() => {setCurrentPage(p => Math.max(1, p - 1)); setExpandedRow(null);}}
                  ><i className="bi bi-chevron-left"></i> Prev</button>
                  <span className="fw-bold" style={{fontSize:'12px'}}> Page {currentPage} of {totalPages} </span>
                  <button 
                    className="btn btn-sm btn-outline-secondary py-1 px-2" 
                    disabled={currentPage === totalPages} 
                    onClick={() => {setCurrentPage(p => Math.min(totalPages, p + 1)); setExpandedRow(null);}}
                  >Next <i className="bi bi-chevron-right"></i></button>
                </div>
              </div>
            )}
          </div>

        </div>
      </div>

      <style jsx>{`
        .report-container { padding: 0; font-size: 12px;}
        .report-card { background: white; border-radius: 8px; box-shadow: 0 1px 10px rgba(0,0,0,0.05); border: 1px solid #e0e6ed; overflow: hidden; }
        
        .card-header { background: var(--theme-color, #0088cc); padding: 8px 15px; }
        .header-left { display: flex; align-items: center; gap: 10px; color: white; }
        .header-icon { width: 32px; height: 32px; background: rgba(255, 255, 255, 0.2); border-radius: 6px; display: flex; align-items: center; justify-content: center; font-size: 16px; }
        .header-text h5 { margin: 0; font-size: 15px; font-weight: 700; }
        .header-text p { margin: 0; color: rgba(255, 255, 255, 0.85); font-size: 11px; }

        .tabs-header { display: flex; background: #f8fafc; border-bottom: 1px solid #e0e6ed; padding: 0 15px; gap: 5px; overflow-x: auto; }
        .tab-btn { padding: 10px 14px; border: none; background: transparent; color: #64748b; font-weight: 600; font-size: 12px; cursor: pointer; border-bottom: 2px solid transparent; display: flex; gap: 6px; align-items: center; white-space: nowrap; }
        .tab-btn:hover { color: var(--theme-color, #0088cc); }
        .tab-btn.active { color: var(--theme-color, #0088cc); border-bottom-color: var(--theme-color, #0088cc); background: white; border-radius: 6px 6px 0 0; border: 1px solid #e0e6ed; border-bottom: none; position: relative; top: 1px; }

        .card-content { padding: 15px; }
        .filter-bar { display: flex; gap: 8px; background: #f8fafc; padding: 10px; border-radius: 6px; border: 1px solid #e0e6ed; margin-bottom: 12px; align-items: flex-end; flex-wrap: wrap; }
        .form-group { display: flex; flex-direction: column; min-width: 120px; }
        .form-group label { font-size: 11px; font-weight: 600; margin-bottom: 3px; color: #475569; }
        .form-input { padding: 4px 8px; border: 1px solid #cbd5e1; border-radius: 4px; font-size: 12px; height: 30px; outline: none; }
        
        .btn-search { padding: 0 15px; background: var(--theme-color, #0088cc); color: white; border: none; border-radius: 4px; font-weight: 600; cursor: pointer; height: 30px; font-size: 12px; transition: 0.2s; }
        
        .summary-cards { display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 10px; margin-bottom: 15px; }
        .s-card { padding: 12px; border-radius: 8px; color: white; position: relative; overflow: hidden; box-shadow: 0 2px 4px rgba(0,0,0,0.1); }
        .s-card.total { background: linear-gradient(135deg, #3b82f6, #2563eb); }
        .s-card.cash { background: linear-gradient(135deg, #10b981, #059669); }
        .s-card.upi { background: linear-gradient(135deg, #0ea5e9, #0284c7); }
        .s-label { font-size: 11px; opacity: 0.9; margin-bottom: 3px; text-transform: uppercase; }
        .s-value { font-size: 18px; font-weight: 700; }
        .s-sub { font-size: 10px; opacity: 0.8; margin-top: 2px; }

        .table-section { background: white; border-radius: 6px; border: 1px solid #e0e6ed; overflow: hidden; }
        .table-responsive { overflow-x: auto; }
        .custom-table { width: 100%; border-collapse: collapse; font-size: 12px; }
        .custom-table th { background: #f8fafc; color: #334155; padding: 8px 10px; font-weight: 600; border-bottom: 2px solid #e2e8f0; white-space: nowrap; }
        .custom-table td { padding: 6px 10px; border-bottom: 1px solid #f1f5f9; vertical-align: middle; color: #1e293b; }
        
        .text-start { text-align: left !important; }
        .text-center { text-align: center !important; }
        .text-end { text-align: right !important; }
        .fw-bold { font-weight: 700; }
        .fw-medium { font-weight: 500; }
        .text-success { color: #16a34a !important; }
        .text-danger { color: #dc2626 !important; }
        .text-primary { color: var(--theme-color, #0088cc) !important; }
        .text-muted { color: #64748b !important; }
        .empty-state { text-align: center; padding: 30px; color: #94a3b8; font-style: italic; }
      `}</style>
    </div>
  );
};

export default PurchaseReports;